module.exports = __webpack_public_path__ + "frontend/images/languages/eu@2x.png?8f77c56ca82019c0c670fe904da763b5";